export default {
  getCntAccKeyList: state => state.cnt,
  getGridDataAccKeyList: state => state.gridData,
  getSearchParamAccKeyList: state => state.searchParam,
  getProjectListAccKeyList: state => state.projectList,
  getColumnHeaderAccKeyList: state => state.columnHeaderList,
  getColumnNameAccKeyList: state => state.columnNameList,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/list/accKeyListGetter.js